var map = {
	"./tcrs_en_EN/background_gradient.png": 4972,
	"./tcrs_en_EN/header_gradient.png": 7420,
	"./tcrs_en_EN/header_logo_narrow.png": 1889,
	"./tcrs_en_EN/header_logo_wide.svg": 790,
	"./tcrs_en_EN/login_logo.svg": 8938,
	"./troy_de_DE/background_gradient.png": 5233,
	"./troy_de_DE/header_gradient.png": 9841,
	"./troy_de_DE/header_logo_narrow.png": 3747,
	"./troy_de_DE/header_logo_wide.svg": 2630,
	"./troy_de_DE/login_logo.svg": 8250,
	"./troy_nl_NL/background_gradient.png": 6561,
	"./troy_nl_NL/header_gradient.png": 4208,
	"./troy_nl_NL/header_logo_narrow.png": 5480,
	"./troy_nl_NL/header_logo_wide.svg": 6940,
	"./troy_nl_NL/login_logo.svg": 2666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7467;